export enum ELoadingOrderStatus {
  NEW = "N",
  IN_PROGRESS = "I",
  COMPLETE = "C",
  DELETE = "D",
}
